/* @generated from adl module ferovinum.datacontracts.expenseorigin */

import * as ADL from './../../runtime/adl';
import * as common from './../../common';
import * as common_strings from './../../common/strings';

export interface ExpenseOriginRawRecord {
  id: common_strings.StringNE;
  expenseId: common_strings.StringNE;
  originType: common_strings.StringNE;
  purchaseRequestId: (common_strings.StringNE|null);
  productionOrderTaskRunId: (common_strings.StringNE|null);
  saleOrderId: (common_strings.StringNE|null);
  createdAt: common.Instant;
  updatedAt: common.Instant;
}

export function makeExpenseOriginRawRecord(
  input: {
    id: common_strings.StringNE,
    expenseId: common_strings.StringNE,
    originType: common_strings.StringNE,
    purchaseRequestId: (common_strings.StringNE|null),
    productionOrderTaskRunId: (common_strings.StringNE|null),
    saleOrderId: (common_strings.StringNE|null),
    createdAt: common.Instant,
    updatedAt: common.Instant,
  }
): ExpenseOriginRawRecord {
  return {
    id: input.id,
    expenseId: input.expenseId,
    originType: input.originType,
    purchaseRequestId: input.purchaseRequestId,
    productionOrderTaskRunId: input.productionOrderTaskRunId,
    saleOrderId: input.saleOrderId,
    createdAt: input.createdAt,
    updatedAt: input.updatedAt,
  };
}

const ExpenseOriginRawRecord_AST : ADL.ScopedDecl =
  {"moduleName":"ferovinum.datacontracts.expenseorigin","decl":{"annotations":[{"value":{"datasetName":"raw_expense_origins"},"key":{"moduleName":"ferovinum.datacontracts.common","name":"RawExportDataset"}}],"type_":{"kind":"struct_","value":{"typeParams":[],"fields":[{"annotations":[],"serializedName":"id","default":{"kind":"nothing"},"name":"id","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"expenseId","default":{"kind":"nothing"},"name":"expenseId","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"originType","default":{"kind":"nothing"},"name":"originType","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}},{"annotations":[],"serializedName":"purchaseRequestId","default":{"kind":"nothing"},"name":"purchaseRequestId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"productionOrderTaskRunId","default":{"kind":"nothing"},"name":"productionOrderTaskRunId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"saleOrderId","default":{"kind":"nothing"},"name":"saleOrderId","typeExpr":{"typeRef":{"kind":"primitive","value":"Nullable"},"parameters":[{"typeRef":{"kind":"reference","value":{"moduleName":"common.strings","name":"StringNE"}},"parameters":[]}]}},{"annotations":[],"serializedName":"createdAt","default":{"kind":"nothing"},"name":"createdAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}},{"annotations":[],"serializedName":"updatedAt","default":{"kind":"nothing"},"name":"updatedAt","typeExpr":{"typeRef":{"kind":"reference","value":{"moduleName":"common","name":"Instant"}},"parameters":[]}}]}},"name":"ExpenseOriginRawRecord","version":{"kind":"nothing"}}};

export const snExpenseOriginRawRecord: ADL.ScopedName = {moduleName:"ferovinum.datacontracts.expenseorigin", name:"ExpenseOriginRawRecord"};

export function texprExpenseOriginRawRecord(): ADL.ATypeExpr<ExpenseOriginRawRecord> {
  return {value : {typeRef : {kind: "reference", value : snExpenseOriginRawRecord}, parameters : []}};
}

export const _AST_MAP: { [key: string]: ADL.ScopedDecl } = {
  "ferovinum.datacontracts.expenseorigin.ExpenseOriginRawRecord" : ExpenseOriginRawRecord_AST
};
